import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

/**
 * Shared confirmation dialog used by filing-info entry sheets (role0 filing
 * prerequisites and role1 filing info) when the user re-submits a previously
 * completed filing-info form. Warns that downstream sheets may be overwritten
 * and asks them to review before continuing the conversion.
 *
 * Imports limited to DialogModule + ButtonModule (ISP).
 */
@Component({
  selector: 'app-filing-info-confirmation-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  templateUrl: './filing-info-confirmation-dialog.component.html',
  styleUrls: ['./filing-info-confirmation-dialog.component.css'],
})
export class FilingInfoConfirmationDialogComponent {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() title: string = 'Filing Information Confirmation';

  @Input() bodyParagraphs: string[] = [
    'Any changes to the values may affect the submission template and will require remapping. Hence all edited or updated fields will be overwritten.',
    'Please review and confirm the accuracy of the values to avoid repeated changes and rework.',
  ];

  @Input() backLabel: string = 'Back';
  @Input() convertLabel: string = 'Convert';

  @Output() back = new EventEmitter<void>();
  @Output() convert = new EventEmitter<void>();

  onVisibleChange(value: boolean): void {
    this.visible = value;
    this.visibleChange.emit(value);
  }

  onBackClick(): void {
    this.back.emit();
  }

  onConvertClick(): void {
    this.convert.emit();
  }
}
